import type { Component } from '../components/component.class';

/**
 * Filters a list of components by a case-insensitive search term.
 * Matches against sku, description, and label. Empty/whitespace search
 * returns the full list unchanged.
 *
 * @param components source list (Components collection or plain Array<Component>)
 * @param search search term (case-insensitive)
 * @returns filtered Array<Component>
 */
export const filterComponentsBySearchCfn = (components: Array<Component>, search: string): Array<Component> => {
	const term = (search ?? '').trim().toLowerCase();
	if (term === '') return [...components];

	return components.filter((component) => {
		const sku = (component.sku ?? '').toLowerCase();
		const description = (component.description ?? '').toLowerCase();
		const label = (component.label ?? '').toLowerCase();
		return sku.includes(term) || description.includes(term) || label.includes(term);
	});
};
